module.exports = __webpack_public_path__ + "static/img/omise-logo.9540090.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/omise-logo.jpg
// module id = w9Y2
// module chunks = 3